import { render, staticRenderFns } from "./evaluaciones-individuales-emeritos-2026.vue?vue&type=template&id=61ad87a5&scoped=true&"
import script from "./evaluaciones-individuales-emeritos-2026.componet.ts?vue&type=script&lang=ts&"
export * from "./evaluaciones-individuales-emeritos-2026.componet.ts?vue&type=script&lang=ts&"
import style0 from "./evaluaciones-individuales-emeritos-2026.vue?vue&type=style&index=0&id=61ad87a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ad87a5",
  null
  
)

export default component.exports